import { Routes } from '@angular/router';
import { ServicesComponent } from './pages/services/services.component/services.component';
import { TalkComponent } from './pages/talk/talk.component/talk.component';
import { AgendaComponent } from './pages/agenda/agenda.component';
import { GalleryComponent } from './pages/gallery/gallery.component';
import { RegisterComponent } from './pages/register/register.component';
import { ArenaComponent } from './pages/arena/arena.component';
import { ModalitiesComponent } from './pages/modalities/modalities.component';
import { TrackComponent } from './pages/track/track.component';
import { PackagesComponent } from './pages/packages/packages.component';
import { PlansComponent } from './pages/plans/plans.component';
import { JoinusComponent } from './pages/joinus/joinus.component';
import { HomeComponent } from './pages/home/home.component';

export const routes: Routes = [
  { path: 'joinus', component: JoinusComponent },
  { path: 'home', component: HomeComponent },
  //{ path: 'home', component: JoinusComponent },
 
  //{ path: 'about', component: AboutComponent },
  { path: 'talk', component: TalkComponent },

  { path: 'arena', component: ArenaComponent },
  { path: 'modalities', component: ModalitiesComponent },
  { path: 'track', component: TrackComponent },
  { path: 'gallery', component: GalleryComponent },
  { path: 'register', component: RegisterComponent },
  { path: 'packages', component: PackagesComponent },
  { path: 'plans', component: PlansComponent },
  
  { path: 'agenda', component: AgendaComponent },
  { path: '**', redirectTo: 'joinus' },
  { path: '', pathMatch: 'full', redirectTo: 'joinus' }
];


// export const routes: Routes = [
//   {
//     path: 'home',
//     loadComponent: () => import('./pages/joinus/joinus.component').then((m) => m.JoinusComponent),
//   },
//   {
//     path: 'talk',
//     loadComponent: () =>
//       import('./pages/talk/talk.component/talk.component').then((m) => m.TalkComponent),
//   },
//   {
//     path: 'arena',
//     loadComponent: () => import('./pages/arena/arena.component').then((m) => m.ArenaComponent),
//   },
//   {
//     path: 'modalities',
//     loadComponent: () =>
//       import('./pages/modalities/modalities.component').then((m) => m.ModalitiesComponent),
//   },
//   {
//     path: 'track',
//     loadComponent: () => import('./pages/track/track.component').then((m) => m.TrackComponent),
//   },
//   {
//     path: 'gallery',
//     loadComponent: () => import('./pages/gallery/gallery.component').then((m) => m.GalleryComponent),
//   },
//   {
//     path: 'register',
//     loadComponent: () => import('./pages/register/register.component').then((m) => m.RegisterComponent),
//   },
//   {
//     path: 'packages',
//     loadComponent: () => import('./pages/packages/packages.component').then((m) => m.PackagesComponent),
//   },
//   {
//     path: 'plans',
//     loadComponent: () => import('./pages/plans/plans.component').then((m) => m.PlansComponent),
//   },
//   {
//     path: 'joinus',
//     loadComponent: () => import('./pages/joinus/joinus.component').then((m) => m.JoinusComponent),
//   },
//   {
//     path: 'agenda',
//     loadComponent: () => import('./pages/agenda/agenda.component').then((m) => m.AgendaComponent),
//   },



//   { path: '**', redirectTo: 'joinus' },
//   { path: '', redirectTo: 'joinus' },
// ];
